var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print"},[_c('div',{staticClass:"print-button"},[_c('div',{staticClass:"print-button__block",on:{"click":_vm.print}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"pro-icon-pdf"})])]),_c('div',{ref:"printMe"},[_vm._t("default")],2),_c('img',{ref:"printImage",staticClass:"print-image",attrs:{"src":_vm.output}})])
}
var staticRenderFns = []

export { render, staticRenderFns }